import React, { FC } from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { Person, Document } from 'talent_matching/types';
import DocumentHeader from 'talent_matching/components/shared/document_header';
import DocumentPreview from 'talent_matching/components/shared/document_preview';
import { useUserContext } from 'talent_matching/contexts/user_context';

type ResumeTabPanelProps = {
  candidate: Person | null;
  onOpenDocument: (document: Document) => void;
};

const ResumeTabPanel: FC<ResumeTabPanelProps> = ({
  candidate,
  onOpenDocument,
}) => {
  const { calibrationTerms } = useUserContext();
  const resume = candidate?.resume?.document;

  return (
    <Stack>
      {resume && (
        <Stack direction="column" spacing={1} sx={{ maxHeight: '80vh' }}>
          <Stack spacing={1.5}>
            <DocumentHeader document={resume} candidate={candidate} />
            <Stack sx={{ height: '575px', width: '440px' }}>
              <DocumentPreview
                document={resume}
                hasCalibrationTerms={calibrationTerms.length > 0}
                onClick={() => {
                  onOpenDocument(resume);
                }}
              />
            </Stack>
          </Stack>
        </Stack>
      )}
    </Stack>
  );
};

export default ResumeTabPanel;
